import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ModalEmailService } from './modal-email.service';

@Component({
    selector: 'modal-email',
    templateUrl: 'modal-email.html'
})

export class ModalEmailComponent implements OnInit {
    public showModal;
    public email
    @ViewChild('emailModal') public officeModal:ModalDirective;
    constructor(private modalEmailService: ModalEmailService) { }

    public onHidden():void{
       this.officeModal.hide()
    }

    public closeModal():void{
       this.officeModal.hide()
    }

    ngOnChanges(value) {
    
        (this.showModal) ? this.officeModal.show() : this.officeModal.hide();
    }
    ngOnInit() { 

        this.modalEmailService.getModalListener().subscribe(message => { 
            this.email = message;
            this.officeModal.show()
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/common/modal-email/modal-email.component.ts